import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import SEO from "@/components/SEO";
import FaqAccordion from "@/components/sections/FaqAccordion";
import { FAQS } from "@/lib/constants";
import { faqPageSchema } from "@/lib/structuredData";

const grouped = [
  { title: "Requesting an offer", items: FAQS.slice(0, 6) },
  { title: "Inspection, loans & condition", items: FAQS.slice(6, 9) },
  { title: "Payment & paperwork", items: FAQS.slice(9) },
];

export default function FAQ() {
  return (
    <div data-testid="page-faq">
      <SEO
        title="Frequently Asked Questions — Carfornia Buyers"
        description="Answers to common questions about selling your car to Carfornia Buyers: offer requests vs. real offers, inspections, loans, payment and California title paperwork."
        canonical="https://carforniabuyers.com/faq"
        jsonLd={faqPageSchema()}
      />
      <section className="py-16 lg:py-24 bg-brand-surface">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-brand-blue">FAQ</p>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold text-slate-900 tracking-tight mt-3">
            Everything you’re wondering.
          </h1>
          <p className="text-lg text-slate-600 mt-5 max-w-2xl mx-auto">
            Quick answers to the questions sellers ask us most often. Still stuck? Call or text <a className="text-brand-blue font-semibold" href="tel:+16503396211">(650) 339-6211</a>.
          </p>
        </div>
      </section>

      <section className="py-16 lg:py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12">
          {grouped.map((g) => (
            <div key={g.title}>
              <h2 className="font-display text-2xl font-extrabold text-slate-900 mb-5">{g.title}</h2>
              <FaqAccordion items={g.items} testId={`faq-group-${g.title.toLowerCase().replace(/\s/g, "-")}`} />
            </div>
          ))}
        </div>
      </section>

      <section className="py-14 bg-brand-surface text-center">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-display text-3xl font-extrabold text-slate-900">Still have a question?</h2>
          <p className="text-slate-600 mt-3">Call, text or send a message and we will get back to you as soon as we can.</p>
          <Link to="/contact">
            <Button data-testid="faq-contact-cta" className="mt-6 h-12 px-7 bg-[#0052FF] hover:bg-[#0040CC] text-white font-bold rounded-xl">Contact us <ArrowRight className="w-4 h-4 ml-2" /></Button>
          </Link>
        </div>
      </section>
    </div>
  );
}
